import type { ReactNode } from 'react';
import { Search } from 'lucide-react';
import { cn } from '@/utils/cn';
import { chatLucideIconProps } from './chat-ui';

export function ChatSidebarNavItem({
  icon,
  label,
  isActive = false,
  shortcut,
  onClick,
  disabled = false,
}: {
  icon: ReactNode;
  label: string;
  isActive?: boolean;
  shortcut?: string;
  onClick: () => void;
  disabled?: boolean;
}) {
  const shortcuts = shortcut ? shortcut.split('') : [];

  return (
    <div className="group relative">
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className={cn(
          'h-9 w-full rounded-lg px-2.5 text-left transition-colors duration-150 focus-visible:ring-2 focus-visible:ring-ring/20',
          shortcut && 'pr-14',
          'text-foreground disabled:pointer-events-none disabled:opacity-50',
          isActive
            ? 'bg-black/4 dark:bg-white/4'
            : 'hover:bg-black/6 dark:hover:bg-white/6'
        )}
      >
        <span className="grid w-full min-w-0 grid-cols-[24px_minmax(0,1fr)] items-center gap-x-2">
          <span className="flex size-6 shrink-0 items-center justify-center">
            {icon}
          </span>
          <span className="chat-type-body-sm-strong min-w-0 truncate text-foreground">
            {label}
          </span>
        </span>
      </button>

      {shortcuts.length ? (
        <div className="absolute top-1/2 right-2 flex -translate-y-1/2 items-center gap-1">
          {shortcuts.map(value => (
            <span
              key={value}
              className={cn(
                'size-5 rounded-md bg-muted-foreground/15 text-center text-[11px] leading-[20px] text-muted-foreground/80',
                'opacity-0 group-hover:opacity-100'
              )}
            >
              {value}
            </span>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export function ChatSidebarSearchEntry({
  isActive,
  onClick,
  disabled = false,
}: {
  isActive: boolean;
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <ChatSidebarNavItem
      icon={<Search {...chatLucideIconProps} className="size-4" />}
      label="Search"
      isActive={isActive}
      shortcut="⌘K"
      onClick={onClick}
      disabled={disabled}
    />
  );
}
